enum RouteEndpointsPayment {
  BASE_PAYMENTS = '/invoice',
  DETAIL_PAYMENT = ':id',
  EDIT_PAYMENT = 'edit/:id',
}

export default RouteEndpointsPayment;
